enum TagThemes {
  PURPLE = 'purple',
  GREEN = 'green',
  ORANGE = 'orange',
  YELLOW = 'yellow',
  BLACK = 'black',
  BLUE = 'blue',
  PINK = 'pink',
}

export default TagThemes
